import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import emailImage from '../../../assets/email.png';
import { Button } from '../../Input/Button/Button';
import { DealerLaunchStepProps } from '../types';
import { LinkButton } from '../../Input/Button/LinkButton';
import styles from '../styles.module.scss';

export interface StepInfoGateProps {
  title: string;
  cardTitle: string;
  cardDescription: React.ReactNode | string;
  continueText: string;
}

export const DealerLaunchInfoGate: FunctionComponent<DealerLaunchStepProps<
  StepInfoGateProps
>> = ({
  step: {
    stepProps: { title, cardTitle, cardDescription, continueText },
  },
  prevStep,
  nextStep,
}) => {
  return (
    <div className={classNames(styles.stepContainer, styles.infoGateStep)}>
      <div className={styles.stepTitle}>{title}</div>
      <div className={styles.stepCard}>
        <h1>{cardTitle}</h1>
        {typeof cardDescription === 'string' ? (
          <p>{cardDescription}</p>
        ) : (
          cardDescription
        )}
        <div className={styles.pageNav}>
          <Button
            className={styles.pageNavButton}
            label="Previous"
            onClick={prevStep}
          />
          <div className="spacer" />
          <Button
            className={styles.pageNavButton}
            label={continueText}
            variant="primary"
            onClick={() => nextStep()}
          />
        </div>
      </div>
      <div className={styles.contactFooter}>
        <p>Questions? Contact Us</p>
        <LinkButton
          className={styles.contactLine}
          to="mailto:dealersetup@upstart.com"
          variant="minimal"
          rawLink
        >
          <img src={emailImage} alt="Email" />
          dealersetup@upstart.com
        </LinkButton>
      </div>
    </div>
  );
};
